














import { Vue, Component } from 'vue-property-decorator';

@Component({})
export default class GuardarButton extends Vue {
  handleClick() {
    this.$emit('click');
  }
}
